import React from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse";

const HrTutorialPage = () => {
  return (
    <LayoutDashboard>
      <div className="container-xl py-4">
        <div className="page-header d-print-none mb-4">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">Panduan Modul HR (Berdasarkan Sistem)</h2>
              <div className="text-muted mt-1">
                Petunjuk akurat sesuai menu dan tombol yang tersedia di modul HR saat ini.
              </div>
            </div>
          </div>
        </div>

        <div className="accordion" id="hrTutorialAccordion">
          
          {/* Dashboard & Manage */}
          <div className="accordion-item card mb-3 border-0 shadow-sm">
            <h2 className="accordion-header" id="headingManage">
              <button className="accordion-button bg-light fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseManage" aria-expanded="true" aria-controls="collapseManage">
                1. Pengelolaan Operasional (Menu: HR &gt; Manage)
              </button>
            </h2>
            <div id="collapseManage" className="accordion-collapse collapse show" aria-labelledby="headingManage" data-bs-parent="#hrTutorialAccordion">
              <div className="accordion-body">
                <p>Halaman <strong>Manage</strong> menampilkan kartu-kartu menu untuk operasional harian. Klik tombol <strong>"Access"</strong> pada masing-masing kartu untuk masuk ke halamannya:</p>
                <ul>
                  <li><strong>User Management:</strong> Mengelola data pengguna (user) HR.</li>
                  <li><strong>Attendance Management:</strong> Melacak dan mengelola data kehadiran (attendance) karyawan.</li>
                  <li><strong>Salary Management:</strong> Memproses dan mengelola penggajian (payroll) karyawan.</li>
                  <li><strong>Schedule Patterns:</strong> Membuat template pola jadwal kerja sebelum diterapkan ke karyawan.</li>
                  <li><strong>Schedule Management:</strong> Menetapkan jadwal/shift kerja kepada karyawan menggunakan pattern yang telah dibuat.</li>
                  <li><strong>Time Off Requests:</strong> Halaman persetujuan (approve/reject) untuk permintaan cuti dan izin karyawan.</li>
                  <li><strong>Overtime Requests:</strong> Halaman persetujuan untuk perintah dan klaim jam lembur karyawan.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Master Data */}
          <div className="accordion-item card mb-3 border-0 shadow-sm">
            <h2 className="accordion-header" id="headingMaster">
              <button className="accordion-button collapsed bg-light fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMaster" aria-expanded="false" aria-controls="collapseMaster">
                2. Data Master HR (Menu: HR &gt; Master)
              </button>
            </h2>
            <div id="collapseMaster" className="accordion-collapse collapse" aria-labelledby="headingMaster" data-bs-parent="#hrTutorialAccordion">
              <div className="accordion-body">
                <p>Halaman <strong>Master</strong> berisi pengaturan data dasar. Klik <strong>"Manage"</strong> pada kartu yang tersedia:</p>
                <ul>
                  <li><strong>Asset Group & Asset Item:</strong> Mengatur kategori aset dan daftar barang inventaris kantor.</li>
                  <li><strong>Insurance:</strong> Mengelola kebijakan dan data asuransi (misalnya BPJS).</li>
                  <li><strong>Facility:</strong> Mengelola daftar fasilitas kantor.</li>
                  <li><strong>Deduction:</strong> Mengelola jenis-jenis potongan gaji.</li>
                  <li><strong>Departments:</strong> Mengelola daftar departemen di perusahaan.</li>
                  <li><strong>Shifts:</strong> Mengelola master jam kerja (jam masuk & jam pulang).</li>
                  <li><strong>Approval Lines:</strong> Mengatur hirarki persetujuan/approver untuk masing-masing user (misalnya untuk cuti).</li>
                  <li><strong>Time Off Policies:</strong> Mengatur kebijakan dan jatah cuti (leave policies).</li>
                  <li><strong>Overtime Policies:</strong> Mengatur kebijakan perhitungan tarif lembur.</li>
                </ul>
                <div className="alert alert-info mt-2">
                  <strong>Catatan:</strong> Menu "Positions" dan "Holidays" saat ini sedang dinonaktifkan dari sistem.
                </div>
              </div>
            </div>
          </div>

          {/* Settings & Reports */}
          <div className="accordion-item card mb-3 border-0 shadow-sm">
            <h2 className="accordion-header" id="headingSettingsReports">
              <button className="accordion-button collapsed bg-light fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSettingsReports" aria-expanded="false" aria-controls="collapseSettingsReports">
                3. Pengaturan & Laporan (Settings & Report)
              </button>
            </h2>
            <div id="collapseSettingsReports" className="accordion-collapse collapse" aria-labelledby="headingSettingsReports" data-bs-parent="#hrTutorialAccordion">
              <div className="accordion-body">
                <h5 className="text-dark">Menu Settings (HR &gt; Setting)</h5>
                <p>Halaman ini digunakan untuk konfigurasi kebijakan sistem.</p>
                <ul>
                  <li><strong>Salary Settings:</strong> Mengonfigurasi struktur perhitungan gaji (Klik tombol "Configure").</li>
                </ul>
                
                <h5 className="text-dark mt-4">Menu Laporan (HR &gt; Report)</h5>
                <p>Halaman ini menghasilkan laporan operasional. Klik tombol <strong>"View"</strong> untuk melihatnya:</p>
                <ul>
                  <li><strong>Asset Report:</strong> Laporan pelacakan manajemen aset.</li>
                  <li><strong>Attendance Report:</strong> Laporan kehadiran dan presensi karyawan.</li>
                  <li><strong>Salary Report:</strong> Laporan penggajian dan pencairan gaji.</li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </LayoutDashboard>
  );
};

export default HrTutorialPage;
